// reintro.js
//
// "Ver la app como si entraras por primera vez" para las cuentas del rescate
// de inactivos (spec .claude/specs/rescate-inactivos/, R9 y R10). El backend
// marca la cuenta (`/api/user/me/` → `reintro_pendiente: true`) y la apaga
// con `POST /api/user/me/reintro-vista/` cuando la intro del Turno se cierra.
//
// El onboarding (R9) se muestra UNA vez por sesión del navegador: la marca vive
// en sessionStorage, no en localStorage ni en el servidor, porque el servidor
// solo apaga la marca al cerrar la intro del Turno y si el médico abandona el
// wizard sin llegar a ella no debe quedar atrapado en un bucle de redirecciones
// (el wizard mismo llama a `destinoSegunCuenta` al salir con "Completar
// después" / "Atrás": sin esta marca lo devolvería al wizard).

export const CLAVE_REINTRO_MOSTRADA = "smartdx:reintro-onboarding-mostrado";

// Rutas desde las que la redirección al onboarding puede dispararse (R9).
export const RUTAS_REINTRO = ["/", "/home", "/turno"];

const yaMostrada = () => {
  try {
    return sessionStorage.getItem(CLAVE_REINTRO_MOSTRADA) === "1";
  } catch {
    // Sin sessionStorage (modo privado estricto) no hay dónde recordarlo: se
    // trata como "ya mostrada" para no atrapar a la cuenta en un bucle.
    return true;
  }
};

export const marcarReintroMostrada = () => {
  try {
    sessionStorage.setItem(CLAVE_REINTRO_MOSTRADA, "1");
  } catch {
    /* ver yaMostrada */
  }
};

export const reintroPorMostrar = (user) =>
  Boolean(user && user.reintro_pendiente === true && !yaMostrada());
